<template>
  <div class="container">
    <modem-command-details v-if="command" :command="command"/>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo () {
      const commandType = this.command ? this.command.type : ''
      return {title: `Команда ${commandType}`}
    },
    props: {
      id: {},
    },
    data () {
      return {}
    },
    asyncComputed: {
      command () {
        return api
          .get(`commands/${this.id}`)
          .then(({data}) => data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/commands/_id.vue